import React, { forwardRef, Ref } from 'react';
import classnames from 'classnames';
import { Input as AntdInput, InputProps, InputRef } from 'antd';

import TextArea from './TextArea';
import Password from './Password';

import './style.scss';

const PREFIX = 'music';

function _Input(props: InputProps, ref: Ref<InputRef>) {
  const { className, ...rstProps } = props;

  return (
    <AntdInput
      className={classnames(
        `${PREFIX}-input`,
        className
      )}
      ref={ref}
      {...rstProps}
    />
  );
}

type CompoundedComponent = React.ForwardRefExoticComponent<InputProps & React.RefAttributes<InputRef>> & {
  Group?: typeof AntdInput.Group;
  Search?: typeof AntdInput.Search;
  TextArea?: typeof AntdInput.TextArea;
  Password?: typeof AntdInput.Password;
};

const Input: CompoundedComponent = forwardRef(_Input);

Input.TextArea = TextArea;
Input.Password = Password;
Input.Group = AntdInput.Group;
Input.Search = AntdInput.Search;

export default Input;
